<section class="main-container">
  <!-- Stepper (Sidebar) -->
  <aside class="side-right">
    <app-stepper [steps]="steps" [currentStep]="currentStep"></app-stepper>
  </aside>

  <!-- Main Content -->
  <div class="center-container">
    <!-- Step 1 -->
    <div *ngIf="currentStep === 1">
      <p class="mb-8 text-generic">
        {{ 'FORGOT_PASSWORD.PLEASE_ENTER_USERNAME' | translate }}
      </p>

      <form [formGroup]="userNameForm" class="space-y-4" (ngSubmit)="handleStep1()">
        <app-input-field label="{{ 'LOGIN.USERNAME' | translate }}" placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}"
          [control]="usernameControl">
        </app-input-field>

        <app-button text="{{'LOGIN.CONTINUE' | translate}}" type="submit" variant="primary" size="lg" extraClass="mt-8"
          [disabled]="userNameForm.invalid">
        </app-button>
      </form>
    </div>

    <!-- Step 2 -->
    <div *ngIf="currentStep === 2">
      <p class="mb-8 text-generic">
        {{'CHANGE_PASSWORD.ENTER_NEW_PASSWORD' | translate}}
      </p>

      <app-password-change (submitAction)="handleStep2($event)"></app-password-change>
    </div>
  </div>
</section>